module.exports = __webpack_public_path__ + "static/media/rnr-logo.c7702193.png";